// Styles for CobrandOBannerFeature go here.
import styled from 'styled-components';

export const StyledCobrandOBannerFeature = styled.div``;
